module.exports = "https://static.wanderu.com/ui-react/_next/static/media/es.629aba7b.svg";